import React from 'react';
import { Row as BSRow, RowProps as BSRowProps } from 'react-bootstrap';
import './Row.scss';

export interface RowProps extends BSRowProps {
    align?: 'start' | 'end' | 'center' | 'evenly';
    visible?: boolean
}

export const Row: React.FC<RowProps> = (props) => {
    if(props.visible === undefined || props.visible === true){
        return (
            <BSRow {...props}>{props.children}</BSRow>
        )
    }
    else{
        return null;
    }
}

(Row as any).displayName = "Row";